var $dad545c909cfec2d$exports = {};
const $dad545c909cfec2d$var$mainText = document.querySelector('.main-text');
const $dad545c909cfec2d$var$year = document.querySelector('.year');
// Auto typing functionality
const $dad545c909cfec2d$var$text = "Organize it all with Queue up \u2014 One space at a time";
let $dad545c909cfec2d$var$array = [];
function $dad545c909cfec2d$var$AutoType(text) {
    text.split('').forEach((element, index)=>{
        setTimeout(()=>{
            $dad545c909cfec2d$var$array.push(element);
            $dad545c909cfec2d$var$mainText.textContent = $dad545c909cfec2d$var$array.join('');
        }, index * 50);
    });
}
$dad545c909cfec2d$var$AutoType($dad545c909cfec2d$var$text);
// Copyright year
const $dad545c909cfec2d$var$curYear = new Date().getFullYear();
$dad545c909cfec2d$var$year.textContent = $dad545c909cfec2d$var$curYear;


//# sourceMappingURL=queue-up.05a9f86c.js.map
